<div
  *ngIf="
    !controlIsDisabled('HousingContactName') &&
    !controlIsDisabled('HousingContactPhone')
  "
  class="row"
>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="landlordName">
        Landlord Name
        <span
          *ngIf="controlIsRequired('HousingContactName')"
          class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="landlordName"
        placeholder="Name"
        type="text"
        [formControl]="getFormControl('HousingContactName')"
        aria-label="Landlord name"
      />
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="landlordPhone">
        Landlord Phone Number
        <span
          *ngIf="controlIsRequired('HousingContactPhone')"
          class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="landlordPhone"
        placeholder="Phone number"
        type="text"
        [formControl]="getFormControl('HousingContactPhone')"
        aria-label="Landlord phone number"
      />
    </div>
  </div>
</div>

<div *ngIf="!controlIsDisabled('MonthlyCost')" class="row">
  <div class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="monthlyRent">
        Monthly Rent
        <span *ngIf="controlIsRequired('MonthlyCost')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="monthlyRent"
          placeholder="Amount"
          type="number"
          min="0"
          step="100"
          [formControl]="getFormControl('MonthlyCost')"
          aria-label="Monthly rent (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
</div>

<div *ngIf="!controlIsDisabled('Lienholder')" class="row">
  <div class="col-12 col-md-12 col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="lienholder">
        Lienholder
        <span *ngIf="controlIsRequired('Lienholder')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="lienholder"
        placeholder="Payments made to"
        type="text"
        [formControl]="getFormControl('Lienholder')"
        aria-label="Lienholder (payments made to)"
      />
    </div>
  </div>
</div>

<div
  *ngIf="
    !controlIsDisabled('MortgageBalance') && !controlIsDisabled('MarketValue')
  "
  class="row"
>
  <div class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="balanceOwed">
        Balance Owed
        <span *ngIf="controlIsRequired('MortgageBalance')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="balanceOwed"
          placeholder="Amount"
          type="number"
          min="0"
          step="1000"
          [formControl]="getFormControl('MortgageBalance')"
          aria-label="Balance owed (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    <div class="mb-3">
      <label class="form-label" for="marketValue">
        Market Value
        <span *ngIf="controlIsRequired('MarketValue')" class="color-error"
          >*</span
        >
      </label>
      <div class="input-group mb-3">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          id="marketValue"
          placeholder="Amount"
          type="number"
          min="0"
          step="1000"
          [formControl]="getFormControl('MarketValue')"
          aria-label="Market value (to the nearest dollar)"
        />
      </div>
    </div>
  </div>
</div>
